import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiChrome } from 'react-icons/fi';

// Mirror of MicrosoftStoreBtn for the Chrome Web Store. Kept as its own component
// rather than a prop on the Microsoft one so each store keeps its own wording and
// icon, which is what the two stores' brand rules ask for.
const ChromeStoreBtn = ({ accentColor = 'bg-accent-amber', className = '', href = '#' }) => {
  return (
    <a
      href={href}
      className={`btn-primary ${accentColor} text-white ${className} decoration-transparent`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <SafeIcon icon={FiChrome} className="w-5 h-5" />
      <div className="flex flex-col items-start leading-none">
        <span className="text-[10px] uppercase tracking-wider opacity-80">Available in the</span>
        <span className="text-sm font-semibold">Chrome Web Store</span>
      </div>
    </a>
  );
};

export default ChromeStoreBtn;
